module.exports = __webpack_public_path__ + "img/shot-2.f500eda3.png";